/**
 * Extrai o ID de uma referência que pode chegar como string crua ou objeto populado
 * (ex.: `{_id, name}`) — mesma necessidade em vários pontos da base (alguns endpoints populam
 * assigneeId/providerId/clientId, outros retornam só o ID).
 */
export function getEntityId(value: unknown): string {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const obj = value as { _id?: string; id?: string };
  return obj._id || obj.id || '';
}
